<footer class="w-full h-[90px] bg-[var(--aqua)] px-8 flex items-center justify-between text-[var(--blue)] font-bold">
  <div class="space-x-6">
    <span>© EQ Labs Ltd 2025</span>
    <a href="/TOC" class="hover:underline">Terms & Conditions</a>
    <a href="/RequestPasswordReset" class="hover:underline">Reset password</a>
  </div>

  <div class="flex items-center space-x-5 mr-40">
    <a href="https://www.instagram.com/mood_first/" target="_blank">
      <img src="/images/social_instagram.png" alt="Instagram" class="w-7 h-7" />
    </a>
    <a href="https://www.facebook.com/Mood-First-106971104910396" target="_blank">
      <img src="/images/social_facebook.png" alt="Facebook" class="w-7 h-7" />
    </a>
    <a href="https://twitter.com/MoodFirst2" target="_blank">
      <img src="/images/social_twitter.png" alt="Twitter" class="w-7 h-7" />
    </a>
    <a href="https://www.linkedin.com/company/mood-first" target="_blank">
      <img src="/images/social_linkedin.png" alt="LinkedIn" class="w-7 h-7" />
    </a>
  </div>
</footer>


<!-- <footer>
<span class="footerItem">Copyright EQ Labs Ltd  2023.</span>
<span class="footerItem"><a href="/TOC">Terms & Conditions</a></span>
<span class="footerItem"><a href="/RequestPasswordReset">Reset password</a></span>

<span class="socialLinks">
  <a target="_new" href="https://www.instagram.com/mood_first/" class="socialLink"><img class="socialImage" src="/images/social_instagram.png" /></a>
  <a target="_new" href="https://www.facebook.com/Mood-First-106971104910396" class="socialLink"><img class="socialImage" src="/images/social_facebook.png" /></a>
  <a target="_new" href="https://twitter.com/MoodFirst2" class="socialLink"><img class="socialImage" src="/images/social_twitter.png" /></a>
  <a target="_new" href="https://www.linkedin.com/company/mood-first" class="socialLink"><img class="socialImage" src="/images/social_linkedin.png" /></a>
</span>
</footer>

<style>
 footer {padding-left:90px; padding-right: 90px; height: 90px; background-color: var(--aqua) ; position: absolute; left: 0; bottom: 0; width: 100%; flex-grow: 1}
 .footerItem {line-height: 90px; color: var(--blue); font-weight: bold; margin-right: 20px}
 .socialLinks {float: right; line-height: 90px; margin-top: 8px}
 .socialLink {margin-left: 20px}
 .socialImage {height: 28px; width: 28px;}
</style> -->
